// // check on load if viewport reached
// jQuery(document).ready(function() {
//     animateCount<?php echo $rand; ?>();
// });

// // Animate count after viewport reached
// jQuery(window).scroll(function() {
//     animateCount<?php echo $rand; ?>();
// });

// function animateCount<?php echo $rand; ?>() {
//     // Check if count is in viewport
//     if (!chkViewport[<?php echo $rand; ?>]) {
//         var el = document.getElementById('statistics-value-<?php echo $rand; ?>');

//         if (typeof elementInViewport === "function" && elementInViewport(el)) {
//             // animate from 0 to count
//             chkViewport[<?php echo $rand; ?>] = true;
//             jQuery('#statistics-value-<?php echo $rand; ?>').animateNumber({
//                     number: <?= $entry['content_icon']['statistik']; ?>,
//                     numberStep: comma_separator_number_step
//                 },
//                 // random animation speed
//                 <?php echo rand(1000, 2000); ?>
//             );
//         }
//     }
// }
import { isPartOfViewport } from "../../../resources/js/helper/helper";

(function () {
  const counter = document.querySelectorAll(".animate-counter");

  if (counter) {
    const comma_separator_number_step =
      jQuery.animateNumber.numberStepFactories.separator(".");

    document.addEventListener("scroll", (event) => {
      for (let i = 0; i < counter.length; i++) {
        const inViewport = isPartOfViewport(counter[i]);

        if (inViewport && counter[i].dataset.count) {
          jQuery(counter[i]).animateNumber(
            {
              number: counter[i].dataset.count,
              numberStep: comma_separator_number_step,
            },
            {
              easing: "swing",
              duration: Math.random() * (2000 - 1000) + 1000, // random millisecond value between 1000 and 2000
            }
          );
        }
      }
    });
  }
})();
